import React from 'react';
import PropTypes from 'prop-types';

import BlogPost from '../../common/components/BlogPost';
import { StyledPostsSection } from './postsSection.styled';

const PostsSection = ({ sectionTitle, posts, postProps }) => {
  return (
    <StyledPostsSection>
      {sectionTitle && <h3>{sectionTitle}</h3>}
      <div className="posts-wrapper">
        {
          posts.map(
            (post, i) =>
              <BlogPost
                key={post.post_id || post.video_post_id}
                {...post}
                direction={i === 0 ? 'column' : 'row'}
                {...postProps}
              />
          )
        }
      </div>
    </StyledPostsSection>
  );
}

PostsSection.propTypes = {
  sectionTitle: PropTypes.string,
  posts: PropTypes.array.isRequired,
  postProps: PropTypes.object
};

PostsSection.defaultProps = {
  posts: [],
  postProps: {}
};

export default PostsSection;
